import FormRegisterComposer from '../../../composers/FormRegisterComposer';

export default function FormRegisterPage(): JSX.Element {
  return <FormRegisterComposer />;
}
